import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import './DiscoverCard.scss';
import glassesIconMobile from 'images/glasses-icon-mobile.svg';
import glassesIconDesktop from 'images/glasses-icon-desktop.svg';
import SolidButton from 'components/content/Button/SolidButton.js';

export class DiscoverCard extends Component {
	constructor() {
		super();
		this.launchDiscoverModal = this.launchDiscoverModal.bind(this);
	}

	launchDiscoverModal() {
		this.props.history.push({pathname: '/discover'});
	}

	render() {
		return (
			<div className="discoverCard">
				<img 
					src={glassesIconMobile} 
					srcSet={`${glassesIconDesktop} 720w`} 
					alt="Glasses Icon" 
					className="discoverCard__glasses-icon">
				</img>
				<div className="discoverCard__title">Discover New Books</div>
				<div className="discoverCard__text">
					Use our discovery tool to get book 
					recommendations customized just for you.
				</div>
				<SolidButton text="GET RECOMMENDATIONS" handleClick={this.launchDiscoverModal}/>
			</div>
		)
	}
}

export default withRouter(DiscoverCard)